
























































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import LocationService from '@/services/LocationService';
import Location from '@/services/Location';
import { KCardFooter, KCardFooterBtn, KSpinner, KMapListManager } from '@kasasa/fbase-components';
import pullAllBy from 'lodash/pullAllBy';
import reduce from 'lodash/reduce';
import { Route } from 'vue-router';
import { Dialog, NoticeResponse, Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import orderby from 'lodash/orderBy';

const mapReduceIds = (locations: Location[]) => {
	return reduce(locations, function(str, location) {
			return str + ',' + location.id;
		}, '0');
};

const saved = new Alert('Live locations are successfully updated.', NoticeClass.SUCCESS);
saved.setTimeout(6000);


@Component({
	components: {
		KMapListManager,
		KCardFooter, 
		KCardFooterBtn, 
		KSpinner
	}
})
export default class SiteSetupPage extends Vue {

	locationSvc = new LocationService(this.$store);
	allLocations: Location[] = [];
	siteLocations: Location[] = [];
	mappedLocations = '';
	loadedStatus = 'unloaded';

	get editable() {
		return this.$route.meta.mode == 'edit';
	}

	@Watch('$route', { immediate: true, deep: true })
	loadData() {
		this.loadedStatus = 'unloaded';
		this.locationSvc.findAll(this.$route.params.clientId, {includeDisabled: 1})
			.then(resp => {
				this.allLocations = orderby(resp.data.data, [location => location.title.toLowerCase()], ['asc']);
				return this.locationSvc.findAllActiveLocations(this.$route.params.clientId, this.$route.params.id)
			})
			.then(resp => {
				this.siteLocations = resp.data.data;
				// remove current set locations from the allLocations to make available
				pullAllBy(this.allLocations, this.siteLocations, 'id');
				this.storeSites();
				this.loadedStatus = 'loaded';
			})
			.catch(() => {
				// no errors besides 401, 403 and 500 to listen for.
			});
	}

	async beforeRouteLeave(to: Route, from: Route, next: Function) {
		// unsaved changes check
		if (this.loadedStatus == 'loaded' && mapReduceIds(this.siteLocations) !== this.mappedLocations) {
			const dialog = new Dialog('Unsaved Changes', 'You have unsaved changes on this page that will be lost if you leave now. Are you sure?', 'LEAVE WITHOUT SAVING');
			dialog.setDeclineLabel('STAY ON THIS PAGE')
				.setDismissable(false);

			const res = await this.$store.dispatch('notices/add', dialog);
			switch (res) {
				case NoticeResponse.ACCEPT: 
					next();
					break;	
				case NoticeResponse.DECLINE: 
				default:
					// staying on the page	
					break;
			}
		} else {
			next();
		}
	}

	cancelAction() {
		this.$router.push({name: 'SiteMap', params: this.$route.params});
	}

	saveAction() {
		const p = new Promise((resolve) => {
				this.locationSvc.updateActiveLocations(this.$route.params.clientId, this.$route.params.id, this.siteLocations)
					.then(() => {
						this.storeSites();
						this.$store.dispatch('notices/add', saved);
						resolve();
					})
					.catch(() => {
						resolve();
					});
		});
		return p;
	}

	storeSites(): void {
		this.mappedLocations = mapReduceIds(this.siteLocations);
	}

	saveCloseAction() {
		const p = new Promise((resolve) => {
				this.locationSvc.updateActiveLocations(this.$route.params.clientId, this.$route.params.id, this.siteLocations)
					.then(() => {
						this.storeSites();
						this.$store.dispatch('notices/add', saved);
						this.$router.push({name: 'Locations', params: this.$route.params});
						resolve();
					})
					.catch(() => {
						resolve();
					});
		});
		return p;
	}
}
